"use strict";
/**
 * 市场预览图的规格：两张图、两套尺寸、两个体积上限。
 *
 * 为什么是两组而不是一组「越大越好」：
 *
 *   card（800×500，≤400KB）落在市场列表的卡片里。卡片网格是
 *   `minmax(210px, 1fr)`，实际宽度 210–320px，800 已经覆盖 2x 屏。
 *   之前定的 1600×1000 是这个尺寸的 5.7 倍 —— 多出来的像素全被浏览器
 *   缩掉，却把体积顶到 600KB 以上，于是要么过不了校验，要么必须把图
 *   压得很脏才能过。规格定错，压得再狠也是错的方向。
 *
 *   hero（1600×1000，≤800KB）是点开卡片后看的那张。这张才是说服客户
 *   下单的图，所以它要够大够清楚，体积上限也就必须给足。
 *
 * 这个文件是**唯一出处**：包目录校验（scripts/theme/validate.ts）、
 * 上传票据接口、工坊出图，三处读同一份常量。分开写三遍的下场是
 * 「命令行过了、后台上传不过」这种谁都不信的报错。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.THEME_PREVIEW_ACCEPT = exports.THEME_PREVIEW_MIME = exports.THEME_PREVIEW_KINDS = exports.THEME_PREVIEW_SPEC = void 0;
exports.isThemePreviewMime = isThemePreviewMime;
exports.describePreviewSpec = describePreviewSpec;
exports.THEME_PREVIEW_SPEC = {
    card: { width: 800, height: 500, maxBytes: 400 * 1024 },
    hero: { width: 1600, height: 1000, maxBytes: 800 * 1024 },
};
exports.THEME_PREVIEW_KINDS = ['card', 'hero'];
/** 上传接口接受的文件类型。只收 PNG 与 WebP —— 见下方注释 */
exports.THEME_PREVIEW_MIME = {
    'image/png': 'png',
    'image/webp': 'webp',
};
function isThemePreviewMime(value) {
    return typeof value === 'string' && value in exports.THEME_PREVIEW_MIME;
}
/**
 * 为什么收 WebP 而 JPEG 只收在"不推荐"的位置：
 *
 * 网页截图的主体是大色块 + 文字，JPEG 在这种画面上会在色块边缘冒出
 * 彩色噪点，而市场卡片正好是大色块铺满的图 —— 一眼就能看出"糊"。
 * WebP 在同等观感下比 PNG 小 4–6 倍，且色块边缘干净，是这类图的正确格式。
 *
 * PNG 保留是因为工坊与设计稿都直接产出 PNG，逼人转格式只会让人
 * 随便找个在线工具压一遍，质量更不可控。
 */
exports.THEME_PREVIEW_ACCEPT = Object.keys(exports.THEME_PREVIEW_MIME).join(',');
/** 人话的规格说明，报错与发布页提示共用 */
function describePreviewSpec(kind) {
    const spec = exports.THEME_PREVIEW_SPEC[kind];
    const label = kind === 'card' ? '卡片图' : '详情大图';
    return `${label} ${spec.width}×${spec.height}、不超过 ${Math.round(spec.maxBytes / 1024)}KB`;
}
//# sourceMappingURL=preview-spec.js.map